module.exports = __webpack_public_path__ + "static/media/logo.2b00e2c3.svg";